{
  "hello": "¡Hola {name}!",
  "log-in-title": "Introduce tus credenciales para acceder",
  "log-in-data-not-correct": "Las credenciales no son correctas",
  "log-in-forgot": "¿Has olvidado la contraseña?",
  "log-in": "Iniciar sesión",
  "log-in-code-error": "Introduce el código nuevamente",
  "log-in-code-label": "Introduce el código TOTP generado en tu aplicación de autenticación",
  "mfa-intro": "Para completar el proceso de inicio de sesión es necesario activar la autenticación multifactor. Puedes utilizar dos métodos alternativos:",
  "mfa-list-intro": "<ul><li>Escanea el «CÓDIGO QR»</li><li>O haz clic en «Detectar código» e introdúcelo en tu aplicación de autenticación</li></ul><div>Por último, introduce abajo el código generado por la aplicación. Si necesitas ayuda, contacta con <a href=\"mailto:login@coreconsulting.it\">login@coreconsulting.it</a></div>",
  "code-reveal": "DETECTAR CÓDIGO",
  "code-label": "Después, introduce aquí el código generado",
  "code-not-valid": "El código introducido no es válido",
  "confirm": "Confirmar",
  "new-pswrd-title": "Elige tu nueva contraseña",
  "pswrd-not-match": "Las contraseñas no coinciden",
  "password-char": "La contraseña debe contener al menos {length} caracteres",
  "password-numbers": ", al menos un número",
  "password-uppercase": ", una letra mayúscula",
  "password-special": ", un carácter especial",
  "password-rejected": "La contraseña no ha sido aceptada. {message}",
  "onboarding": "Incorporación",
  "reset-username": "Introduce tu nombre de usuario",
  "reset-password": "Restablecer contraseña",
  "send": "Enviar",
  "submission-error": "No se pudo completar la solicitud, inténtalo de nuevo",
  "verify-code-send": "Si el nombre de usuario introducido es válido, recibirás un código de verificación en tu dirección de correo electrónico. Si no recibes el correo, revisa la carpeta de spam o contacta con <a href=\"mailto:login@coreconsulting.it\">login@coreconsulting.it</a>",
  "insert-code": "Introduce el código aquí",
  "insert-code-again": "Introduce nuevamente el código",
  "choose-password": "Elige tu contraseña",
  "copy-code-success": "Código copiado al portapapeles",
  "mfa": "Autenticación multifactor",
  "confirm-password": "Confirmar contraseña",
  "username": "Nombre de usuario",
  "back": "Atrás",
  "log-in-no-provider": "No se ha especificado ningún proveedor de acceso. Accede a esta página a través del enlace de tu aplicación.",
  "error-not-found-title": "Página no encontrada",
  "error-generic-title": "Algo salió mal",
  "error-guidance": "Accede a este servicio a través del enlace de tu aplicación.",
  "home-title": "Servicio de identidad de Coreconsulting",
  "home-intro": "Este es el servicio de identidad y autenticación de Coreconsulting. Su función es iniciar sesión en las aplicaciones que dependen de él, y no está pensado para visitarse de forma independiente.",
  "home-guidance": "Si has llegado directamente a esta página, vuelve a la aplicación que estabas usando y utiliza su enlace de inicio de sesión. El acceso a este servicio solo tiene sentido cuando lo inicia una aplicación conectada.",
  "auth-redirecting-to": "Redirigiendo a",
  "auth-continue": "Continuar",
  "auth-not-you": "¿No eres tú? Vuelve al inicio de sesión",
  "auth-redirecting-in": "Redirigiendo a {host} en {seconds} segundos",
  "auth-redirecting-now": "Redirigiendo a {host}…",
  "auth-already-in": "Ya has entrado en la plataforma",
  "auth-back-to-login": "Volver a la página de inicio de sesión"
}
